export default __webpack_public_path__ + "static/events-dark-e47742e619afc4206d60a0ff51e57256.png";